// Nhận diện URL trong nội dung tin nhắn -> thẻ <a> mở TAB MỚI.
// Dùng chung cho chat nội bộ (ChatWidget/ChatPage) và chat khách hàng (CustomerChat).
const URL_RE = /(https?:\/\/[^\s<>"']+|www\.[^\s<>"']+)/gi;

export function linkifyText(text, keyBase = 'lnk') {
  if (!text || typeof text !== 'string' || !/https?:\/\/|www\./i.test(text)) return text;
  const out = [];
  let last = 0;
  let i = 0;
  let m;
  URL_RE.lastIndex = 0;
  while ((m = URL_RE.exec(text))) {
    let url = m[0];
    // Bỏ dấu câu dính cuối link ("xem https://a.com." -> link không gồm dấu chấm);
    // ')' chỉ bỏ khi link không chứa '(' (giữ nguyên link kiểu wiki có ngoặc).
    while (/[.,!?;:'"”’]$/.test(url) || (url.endsWith(')') && !url.includes('('))) url = url.slice(0, -1);
    if (!url) break;
    if (m.index > last) out.push(text.slice(last, m.index));
    const href = url.startsWith('http') ? url : `https://${url}`;
    out.push(
      // stopPropagation: bấm link chỉ MỞ LINK — không kích hoạt click của bong bóng (mở bảng cảm xúc).
      <a key={`${keyBase}-${i++}`} className="chat-link" href={href} target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()}>
        {url}
      </a>
    );
    last = m.index + url.length;
    URL_RE.lastIndex = last;
  }
  if (last < text.length) out.push(text.slice(last));
  return out;
}
